import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryZone } from '../types/delivery-zone.type';
import { CreateDeliveryZoneRequestDTO } from '../types/dtos/create-delivery-zone.dto';
import { ADMIN_DELIVERY_ZONES_API_PATHS } from '../constants/delivery-zones-api-paths.constants';

type UseCreateDeliveryZoneResult = {
  isSubmitting: boolean;
  createDeliveryZone: (data: CreateDeliveryZoneRequestDTO) => Promise<DeliveryZone | null>;
};

export function useCreateDeliveryZone(): UseCreateDeliveryZoneResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createDeliveryZone = async (data: CreateDeliveryZoneRequestDTO): Promise<DeliveryZone | null> => {
    setIsSubmitting(true);

    try {
      const createdDeliveryZone = await HttpClient.post<DeliveryZone, CreateDeliveryZoneRequestDTO>(
        ADMIN_DELIVERY_ZONES_API_PATHS.CREATE_DELIVERY_ZONE,
        data
      );

      enqueueSnackbar('Zone de livraison créée', { variant: 'success' });
      return createdDeliveryZone;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création de la zone de livraison'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, createDeliveryZone };
}
